export function formatSeconds(totalSeconds) {
    const roundedSeconds = Math.round(totalSeconds);
    const hours = Math.floor(roundedSeconds / 3600);
    const minutes = Math.floor((roundedSeconds % 3600) / 60);
    const seconds = roundedSeconds % 60;
  
    const pad = (n) => String(n).padStart(2, '0');
  
    return `${hours}:${pad(minutes)}:${pad(seconds)}`;
  }